import * as React from 'react';
import { trackForwardedComponent } from '../../util/trackComponent.js';
import { GridItemWithoutMemoized as GridItem } from './GridItem.js';
export { GridItemStyled } from './GridItem.js';

GridItem.displayName = 'GridItem';
var GridItemWithTracking = /*#__PURE__*/React.memo(trackForwardedComponent(GridItem));
GridItemWithTracking.displayName = 'GridItem';

export { GridItemWithTracking as GridItem };
//# sourceMappingURL=externalGridItem.js.map
